import axios from 'axios';

const AVAILABILITY_ENDPOINT = '/invoicing/availability';
const RUN_CYCLE_ENDPOINT = '/invoicing/run-cycle';

/** Mirrors the status values written by the API's InvoicingCycleRun. */
export const RUN_STATUS = {
  TRIGGERED: 'triggered',
  RUNNING: 'running',
  FINISHED: 'finished',
  FAILED: 'failed',
};

/**
 * Why: the app-wide axios interceptor resolves every 4xx and 5xx into a success instead of
 *      rejecting, so `await axios...` never throws on an HTTP error and a try/catch around it
 *      is dead code. Every caller has to test the response itself, and this is the one place
 *      that test is written - a second copy would eventually drift and silently pass failures
 *      through as results.
 * Scope: HTTP-level failure only. It says nothing about whether the run itself succeeded.
 * SRP: answers whether a resolved axios response is actually a failure.
 */
export const requestFailed = response =>
  Boolean(response?.handled) || (response?.status ?? 200) >= 400;

export const isTerminalStatus = status =>
  status === RUN_STATUS.FINISHED || status === RUN_STATUS.FAILED;

export const fetchAvailability = () => axios.get(AVAILABILITY_ENDPOINT);

export const triggerRun = (year, month) => axios.post(RUN_CYCLE_ENDPOINT, { year, month });

export const fetchRun = runId => axios.get(`${RUN_CYCLE_ENDPOINT}/${runId}`);
